export default class BiometricParams {
    constructor(
      public NumeroPreSolicitud: number,
      public Cedula: string,
      public CedulaBenefPrincipal : string,
      public IdBeneficiario: number
    ) {}
  }
  